/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dropdown/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCalendarTime from 'DesignSystem/TysiaCalendarBlocks/TysiaCalendarTime/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Dropdown({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarTimePicker/Dropdown",
  from,
  onClick,
  timezone
  
}) {
  let isBefore = useIsBefore()
let dtTysiacalendartimepickerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCalendarTimePicker.backgroundColor.primary.base'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Dropdown.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-ZqwHxl': dtTysiacalendartimepickerBackgroundcolorPrimaryBase,'--bblr-2-ZqwHxl': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-ZqwHxl': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-ZqwHxl': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-ZqwHxl': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--o-6-ZqwHxl': isBefore ? 0 : 1,'--t-7-ZqwHxl': isBefore ? "0px" : "100%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Dropdown.Vertical:1"
  data-view-path={viewPath}
 className={`views-block fixedScroll`}
>
<div
  data-testid="Dropdown.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tysia_calendar_time"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaCalendarTime(${item?.id ?? item?._id ?? index})`}
      >
<TysiaCalendarTime
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaCalendarTime(${item?.id ?? item?._id ?? index})`}
 onClick={onClick}
 timezone={timezone}
/>
</ListItem>
)}
</div>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }